/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrUserIsAdminResponseDto } from '../../models/dbr-user-is-admin-response-dto';
import { DbrUserLoginDto } from '../../models/dbr-user-login-dto';

export interface UsersControllerIsAdmin$Params {
      body: DbrUserLoginDto
}

export function usersControllerIsAdmin(http: HttpClient, rootUrl: string, params: UsersControllerIsAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrUserIsAdminResponseDto>> {
  const rb = new RequestBuilder(rootUrl, usersControllerIsAdmin.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DbrUserIsAdminResponseDto>;
    })
  );
}

usersControllerIsAdmin.PATH = '/users/is-admin';
